import { useContext } from 'react';
import { createHMRProofContext } from '../utils/createHMRProofContext';
import {
  type ClientInfo,
  type InteractionConfig,
  type RequestType,
} from '../types';
import { type RequestedDataGroup } from './useRequestedData';

export type LayoutData = {
  client?: ClientInfo;
  requestType?: RequestType;
  interactionConfig?: InteractionConfig;
  requestedDataGroups?: RequestedDataGroup[];
  requestedDataLoading?: boolean;
  demo?: boolean;
};

export const LayoutContext = createHMRProofContext<LayoutData>(
  'LayoutContext',
  {},
);

export function useLayoutData(): LayoutData {
  return useContext(LayoutContext);
}
